module.exports = __webpack_public_path__ + "media/images/bulb-49b9e6c6f0a63109c41caad29dc68d86.webp";